import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-tab";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItemBillingSettingsTab extends GenericListTab {
    ConfigurationItem: any;
    BillingMonthDialogWidth = 300;
    msgAll = ko.observable("");
    selectedMonth = ko.observable("");
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 1000;
        this.ConfigurationItem = parent;
    }
    ControllerUrl = "ConfigurationItemBillingSettingsTab";
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let complete: boolean = true;
        if (this.IsNullOrWhitespace(item.ServiceProviderName()) && !item.AllServiceProvider()) {
            complete = false;
        }
        if (this.IsNullOrWhitespace(item.ServiceCategoryGroupName()) && !item.AllServiceGroup()) {
            complete = false;
        }
        if ((this.IsNullOrWhitespace(item.AccountAssignmentTypeName()) || this.IsNullOrWhitespace(item.AccountAssignment())) && !item.AllAccountAssignment()) {
            complete = false;
        }
        if ((this.IsNullOrWhitespace(item.CriteriaAccountAssignmentTypeName()) || this.IsNullOrWhitespace(item.CriteriaAccountAssignment())) && !item.ExportEmptyAccountAssignments()) {
            complete = false;
        }
        if (!complete) {
            let mandatoryDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return $.Deferred<boolean>().resolve(complete).promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
    GetBillingMonthString(item) {
        return Bao.post("ConfigurationItemBillingSettingsTab/GetBillingMonthString", JSON.stringify({
            model: this.MinimizeEntity(item)
        }), (result) => {
            this.ConfigurationItem.BillingMonth(result);
            this.selectedMonth(result);
        });
    }
    MinimizeEntity = function (item) {
        var result = ko.map.toJS(item);
        delete result.Parent;
        return result;
    };
    OpenBillingMonthDialog() {
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemBillingSettingsTab/OpenBillingMonthDialog", JSON.stringify({
            monthString: this.selectedMonth
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                //setzten des Values in BillingMonth
                this.GetBillingMonthString(dialog.ViewModel()).then(() => {
                    dialog.Close();
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.BillingMonthDialogWidth != null) {
                dialog.Width(this.BillingMonthDialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    ;
    // overriding init method to add "all" text to appropriate items
    init(): JQueryPromise<void> {
        return super.init().then(() => {
            this.TabPage.IsLoading(true);
            Bao.Session.GetMessage("msgAll").$deferred
                .then((allString) => {
                this.msgAll(allString);
                this.SetAllMessageToModels();
                this.TabPage.IsLoading(false);
            });
        });
    }
    Get(resetIndex = true) {
        return super.Get.call(this, resetIndex).then(() => this.SetAllMessageToModels());
    }
    SetAllMessageToModels() {
        this.Models().forEach((item) => {
            let model = item as any;
            if (model.AllServiceProvider) {
                model.ServiceProviderName = this.msgAll();
            }
            if (model.AllServiceGroup) {
                model.ServiceCategoryGroupName = this.msgAll();
            }
            if (model.AllAccountAssignment) {
                model.AccountAssignmentTypeName = this.msgAll();
            }
            if (model.ExportEmptyAccountAssignments) {
                model.CriteriaAccountAssignmentTypeName = this.msgAll();
            }
        });
        // hack: to refresh UI we have to "unload" the Models and "reload" them again, because else Knockout does not refresh
        let tmp = this.Models();
        this.Models([]);
        this.Models(tmp);
    }
    // little helper function
    IsNullOrWhitespace(input) {
        if (typeof input === 'undefined' || input == null)
            return true;
        return input.replace(/\s/g, '').length < 1;
    }
    ;
    SetAllMessage(model) {
    }
    ;
}
export default ConfigurationItemBillingSettingsTab;